
<template>
    <v-card >
      <v-container  >
        <v-card-title class="pa-0 mb-2">Обналичивание
          <v-divider class="mx-2" inset vertical></v-divider>
          <export-excel
          :data="filteredSmena"
          :worksheet="'Отчёт о обналичивание '"
          :name="'Обналичивание'"
          :title="'Отчёт о обналичивание - ' + date1  + ' - ' + date2  "
          :fields="json_fields"
          :auto-width="true"

          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>


        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">



            <v-menu class="m-2"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date1"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date1"
                label="Дата 1"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date1"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_karz"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Счеты"
            hide-details
            multiple
            solo
            :items="gnakds"
            item-text="gnakd"
            item-value="gnakd"
            class="m-4"
            @click:clear="get_karz"
            v-model="filters.gnakd" />


          </v-col>

          <v-col cols="12" md="3">

            <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="date2"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date2"
                label="Дата 2"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu2 = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_karz"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>



          <v-btn
          tile
          color="primary"
          class="m-4"
            @click="open_obnal"
        >
          <v-icon left>
            mdi-swap-horizontal
          </v-icon>
          Обналичивать
        </v-btn>



          </v-col>
          <v-col cols="12" md="4">

              <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="search"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table
        :headers="headers"
        :items="filteredSmena"
        class="elevation-1"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
        :search="search">




          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumDolg('mablag')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>

              </tr>
          </template>

          <!-- actions -->
            <template v-slot:item.actions="{ item }">
                <v-icon
                color="warning"
                small
                class="mr-2"
                @click="editItem(item)"
                >
                mdi-pencil
                </v-icon>
                <v-icon
                color="error"
                small
                @click="deleteItem(item)"
                >
                mdi-delete
                </v-icon>
            </template>


        </v-data-table>

        <v-dialog
        v-model="obnal_dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="text-h5">
            Обналичивание
          </v-card-title>

          <v-card-text>

            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Счет"
            hide-details
            solo
            :items="gnakds"
            item-text="gnakd"
            item-value="value"
            class="mt-4"
            @change="get_ostatok"
            v-model="form.id_gnakd" />

            <v-text-field
              v-model="ostatok"
              label="Остаток"
              disabled
              :loading="loading"
              hide-details
              type="number"
              class="mt-4"
            ></v-text-field>

            <v-text-field
              v-model="form.mablag"
              label="Сумма"
              solo
              hide-details
              type="number"
              class="mt-4"
            ></v-text-field>


            <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            :return-value.sync="date3"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.sana"
                label="Дата"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
                class="mt-4"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.sana"
              no-title
              scrollable
            >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="menu3 = false"
                >
                    Отмена
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.menu3.save(form.sana)"
                >
                    OK
                </v-btn>
            </v-date-picker>
            </v-menu>



            <v-textarea
            class="mt-4"
              v-model="form.ezoh"
              label="Комментарий"
              solo
              hide-details
            ></v-textarea>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="obnal_dialog = false"
            >
              Отмена
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="save_obnal"
              :loading="loading"
              :disabled="form.mablag == 0 || Number(form.mablag)> Number(ostatok) || form.id_gnakd == 0 || form.sana == '' || form.mablag==null || form.id_gnakd==null || form.sana==null || form.mablag=='' || form.id_gnakd=='' || form.sana==''"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
      v-model="obnal_edit_dialog"
      max-width="380"
    >
      <v-card>
        <v-card-title class="text-h5">
          Изменение обналичивание {{ info.id_obnal }}
        </v-card-title>

        <v-card-text>

            <v-text-field
            v-model="info.gnakd"
            label="Счёт"
            solo
            hide-details
            disabled
            class="mt-4"
          ></v-text-field>

          <v-text-field
            v-model="info.mablag"
            label="Сумма"
            solo
            hide-details
            type="number"
            class="mt-4"
          ></v-text-field>


          <v-menu
          ref="menu3"
          v-model="menu3"
          :close-on-content-click="false"
          :return-value.sync="date3"
          transition="scale-transition"
          offset-y
          min-width="auto"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="info.sana"
              label="Дата"
              readonly
              v-bind="attrs"
              v-on="on"
              solo
              hide-details
              class="mt-4"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="info.sana"
            no-title
            scrollable
          >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="menu3 = false"
              >
                  Отмена
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menu3.save(info.sana)"
              >
                  OK
              </v-btn>
          </v-date-picker>
          </v-menu>



          <v-textarea
          class="mt-4"
            v-model="info.ezoh"
            label="Комментарий"
            solo
            hide-details
          ></v-textarea>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-1"
            text
            @click="obnal_edit_dialog = false"
          >
            Отмена
          </v-btn>

          <v-btn
            color="warning darken-1"
            text
            @click="edit_obnal"
            :loading="loading"
            :disabled="info.mablag == 0 ||  info.sana == null || info.mablag==null || info.sana==null || info.mablag==''  || info.sana==''"
          >
            Измененить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog delete obnal -->
    <v-dialog
        v-model="obnal_delete_dialog"
        max-width="380"
        >
        <v-card>
          <v-card-title class="headline">Удаление обналичивание {{ info.id_obnal }}</v-card-title>
          <v-card-text>
            Вы действительно хотите удалить обналичивание {{ info.gnakd }} - {{ info.mablag }}сомони?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success darken-1"
              text
              @click="obnal_delete_dialog = false"
            >
              Отмена
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="delete_obnal"
              :loading="loading"
            >
              Удалить
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        </v-dialog>



      </v-container>









      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

    form:{
        id_gnakd: 2,
        mablag:0,
        ezoh:"",
        sana: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    },

    ostatok:0,

    dostup:0,

  searching: "",
  search: "",

    pokupka_dialog: false,
    vozvrat_dialog: false,

  users: [],

  klents:[],

      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,


firma_info:{},

filters: {
    fio: "",
    nom: "",
    valuta: "",
    firma: "",
    comment: "",
    opr:"",
    nom_gnakd:"",
    namud_pardokht:""
},

gnakds: [
    {gnakd: "Душанбе сити", value: 2},
    {gnakd: "Эсхата онлайн", value: 3},
    {gnakd: "Алиф", value: 4},

],

karzdoron: [],

headers: [
        {
              text: '№',
              align: 'start',
              value: 'id_obnal',
          },
          { text: 'Счёт', value: 'gnakd' },
          { text: 'Сумма', value: 'mablag' },
          { text: 'Дата', value: 'sana' },
          { text: 'Описание', value: 'ezoh' },
          { text: 'Действие', value: 'actions', sortable: false },

],

json_fields: {

'ID': 'id_obnal',
'Счёт': 'gnakd' ,
'Сумма': 'mablag' ,
'Дата': 'sana' ,
'Описание': 'ezoh' ,

},




snack: false,
    snackColor: '',
    snackText: '',

loading: false,

furush_card: false,
sumfurush_card: true,
firmaho: [],
vipiska:[],
id_firma:0,

ost_na_nachalo:0,
summa_pokupka:0,
summa_skidka:0,
summa_oplata:0,
summa_vozvrat:0,
ost_dolga:0,
karz_firma:0,
kharid:[],
vozvrat:[],
id:0,

info_pardokht:{},
delete_dialog: false,
edit_dialog: false,
obnals:[],
obnal_dialog: false,
info:{},
obnal_edit_dialog: false,
obnal_delete_dialog: false,
date3: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
menu3: false,














}),

mounted(){
  this.get_karz();
  this.get_ostatok();

},

methods: {


  sumDolg(key) {
  return  this.filteredSmena.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },


  get_karz(){
          this.loading = true;
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)

    this.obnals = [];

    this.loading = true;
              axios.post('/api/get_obnals',{start: this.date1, end: this.date2},
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.obnals = response.data.obnals;
                              }else{
                                  this.loading = false;
                                 console.log(error.response.data.message);
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                            this.loading = false;
                            console.log(error.response.data.message);
                          });
  },

  save_obnal(){

    this.loading = true;
    axios.post('/api/save_obnal',this.form,
            {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                        this.loading = false;
                        this.obnal_dialog = false;
                        this.get_karz();
                        this.snackColor = 'success';
                        this.snackText = 'Сохранено';
                        this.snack = true;

                        this.form.mablag = 0
                        this.form.ezoh = ""
                        this.form.sana = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
                        this.form.id_gnakd = 2
                    }else{
                        this.loading = false;
                       console.log(error.response.data.message);
                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);
                    }
                })
                .catch(error => {
                  this.loading = false;
                  console.log(error.response.data.message);
                });
  },

  editItem(item){
    this.info = item;
    this.obnal_edit_dialog = true;
  },
  deleteItem(item){
    this.info = item;
    this.obnal_delete_dialog = true;
  },

  edit_obnal(){

this.loading = true;
axios.post('/api/edit_obnal',this.info,
        {
            headers: {
                "Content-type": "application/json"
            }
        })
        .then(response => {
                if(response.data.status){
                    this.loading = false;
                    this.get_karz();
                    this.info = {};
                    this.obnal_edit_dialog = false;
                    this.snackColor = 'warning';
                    this.snackText = 'Изменено';
                    this.snack = true;


                }else{
                    this.loading = false;
                   console.log(error.response.data.message);
                    setTimeout(() => {
                        this.snack = false;
                    }, 2000);
                }
            })
            .catch(error => {
              this.loading = false;
              console.log(error.response.data.message);
            });
},

delete_obnal(){

this.loading = true;
axios.post('/api/delete_obnal',this.info,
        {
            headers: {
                "Content-type": "application/json"
            }
        })
        .then(response => {
                if(response.data.status){
                    this.loading = false;
                    this.get_karz();
                    this.info = {};
                    this.obnal_delete_dialog = false;
                    this.snackColor = 'success';
                    this.snackText = 'Удалено';
                    this.snack = true;


                }else{
                    this.loading = false;
                   console.log(error.response.data.message);
                    setTimeout(() => {
                        this.snack = false;
                    }, 2000);
                }
            })
            .catch(error => {
              this.loading = false;
              console.log(error.response.data.message);
            });
},

get_ostatok(){
    this.loading = true;
            axios.get('/api/get_ost_kassa',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;

                                  if(this.form.id_gnakd ==2){
                                    this.ostatok = response.data.dc
                                  }else if(this.form.id_gnakd ==3){
                                    this.ostatok = response.data.eskhata
                                  }else if(this.form.id_gnakd ==4){
                                    this.ostatok = response.data.alif
                                  }

                              }
                          })
                          .catch(error => {
                              this.loading = false;

                          });
},

open_obnal(){
    this.obnal_dialog = true;
    this.get_ostatok();
}






},


computed: {

    filteredSmena() {
    let filter = this.obnals.filter((id_obnal) => {
    for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false
    let dropdownValue = id_obnal[key];
    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},




}

}
</script>

<style  scoped>

</style>





